export default {
    "name": "CreateDashboardReport",
    "kind": "HoudiniMutation",
    "hash": "33061af9d4683f98be2be9bbed956b152341002cc04a24e5072fe8ee9f07a413",

    "raw": `mutation CreateDashboardReport($input: CreateDashboardReportInput!) {
  createDashboardReport(input: $input) {
    dashboardReportId: id
    reportName: name
    reportTitle: title
    json
    shareType
    shareId
    ownerId
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createDashboardReport": {
                "type": "DashboardReport",
                "keyRaw": "createDashboardReport(input: $input)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "dashboardReportId": {
                            "type": "Int",
                            "keyRaw": "dashboardReportId",
                            "visible": true
                        },

                        "reportName": {
                            "type": "String",
                            "keyRaw": "reportName",
                            "visible": true
                        },

                        "reportTitle": {
                            "type": "String",
                            "keyRaw": "reportTitle",
                            "visible": true
                        },

                        "json": {
                            "type": "String",
                            "keyRaw": "json",
                            "visible": true
                        },

                        "shareType": {
                            "type": "DashboardReportShareType",
                            "keyRaw": "shareType",
                            "nullable": true,
                            "visible": true
                        },

                        "shareId": {
                            "type": "Int",
                            "keyRaw": "shareId",
                            "nullable": true,
                            "visible": true
                        },

                        "ownerId": {
                            "type": "Int",
                            "keyRaw": "ownerId",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "CreateDashboardReportInput"
        },

        "types": {
            "CreateDashboardReportInput": {
                "json": "String",
                "name": "String",
                "shareId": "Int",
                "shareType": "DashboardReportShareType",
                "title": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=b37c69d62efe59bbe3f6b0c0cc29d1bcfcbcf3cfc92272fb129e0c37c058a0ba";